import {Spin} from 'antd';
import {useOutletContext} from 'react-router-dom';
import styles from './AiHelpDesk.module.scss';
import {TicketCard} from './components/TicketCard';
import {TicketsTable} from './components/TicketsTable';
import {TicketsChatView} from './components/TicketsChatView';

export const AnonymousTickets = () => {
  const {
    viewMode,
    tickets,
    ticketsLoading,
    currentPage,
    pageSize,
    totalTickets,
    onPageChange,
    refetchTickets,
    chatTickets,
    chatHasMore,
    chatLoadingMore,
    onChatLoadMore,
  } = useOutletContext();

  const emptyMessage = 'No anonymous tickets on this page.';

  if (viewMode === 'chat') {
    return (
      <div className={styles.tabContent}>
        <TicketsChatView
          tickets={chatTickets}
          loading={ticketsLoading && chatTickets.length === 0}
          emptyMessage={emptyMessage}
          hasMore={chatHasMore}
          loadingMore={chatLoadingMore}
          onLoadMore={onChatLoadMore}
        />
      </div>
    );
  }

  if (viewMode === 'list') {
    return (
      <TicketsTable
        tickets={tickets}
        loading={ticketsLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        total={totalTickets}
        onPageChange={onPageChange}
        onChanged={refetchTickets}
      />
    );
  }

  if (ticketsLoading) {
    return (
      <div className={styles.emptyState}>
        <Spin size="large" />
      </div>
    );
  }

  if (tickets.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={styles.gridView}>
      {tickets.map(ticket => (
        <TicketCard
          key={ticket.id}
          ticket={ticket}
          onChanged={refetchTickets}
        />
      ))}
    </div>
  );
};
